import { allRoles, roleDescriptions } from '@flintmint/core-shared/constants';
import { Chip } from '@flintmint/web-shared/components/chip';

import { usePageTitle } from '@/hooks/use-page-title';
import { UsersTable, UsersTableSkeleton } from './users-table';
import { useUsers } from './use-users';
import { useUserRoles } from './use-user-roles';
import { roleChipColor } from './roles-cell';

import styles from './users-page.module.scss';

export const UsersPage = () => {
  usePageTitle('Users');
  const { rolesByUserId, isLoading: rolesLoading, error: rolesError } = useUserRoles();
  const { rows, isLoading, isUsageLoading, error, usageError } = useUsers(rolesByUserId);

  return (
    <>
      <div className={styles.page}>
        <UsersPageHeader />

        {error && <p className={styles.error}>{error}</p>}
        {!error && usageError && <p className={styles.error}>{usageError}</p>}
        {rolesError && <p className={styles.error}>{rolesError}</p>}
        {isLoading ? (
          <UsersTableSkeleton />
        ) : error || rolesError ? null : (
          <UsersTable
            rows={rows}
            rolesByUserId={rolesByUserId}
            rolesLoading={rolesLoading}
            usage={isUsageLoading ? 'loading' : usageError ? 'failed' : 'loaded'}
          />
        )}
      </div>
    </>
  );
};

export const UsersPageSkeleton = () => (
  <div className={styles.page}>
    <UsersPageHeader />
    <UsersTableSkeleton />
  </div>
);

const UsersPageHeader = () => (
  <>
    <div className={styles.header}>
      <h2 className={styles.title}>Users</h2>
    </div>

    <div className={styles.rolesLegend}>
      {allRoles.map((role) => (
        <span key={role} className={styles.rolesLegendEntry}>
          <Chip label={role} color={roleChipColor(role)} />
          <span className={styles.rolesLegendDescription}>{roleDescriptions[role]}</span>
        </span>
      ))}
    </div>
  </>
);
